import { api } from "@/lib/api";

export type CostReportPeriod = "mtd" | "7d" | "30d";

export interface CostReportTotals {
  events: number;
  costBrl: number;
  freshInputTokens: number;
  cachedInputTokens: number;
  outputTokens: number;
  cacheHitPct: number;
}

export interface CostByAgent {
  agentId: string | null;
  agentName: string | null;
  events: number;
  costCents: number;
  costBrl: number;
  inputTokens: number;
  cachedInputTokens: number;
  outputTokens: number;
}

export interface CostByModel {
  provider: string;
  model: string;
  events: number;
  costCents: number;
  costBrl: number;
  inputTokens: number;
  cachedInputTokens: number;
  outputTokens: number;
}

export interface CostTopIssue {
  issueId: string | null;
  issueIdentifier: string | null;
  issueTitle: string | null;
  events: number;
  costCents: number;
  costBrl: number;
}

export interface CostDailyPoint {
  day: string;
  events: number;
  costBrl: number;
}

export type CostKind = "text" | "image" | "video" | "audio" | "other";

export interface CostByKind {
  kind: CostKind;
  events: number;
  costCents: number;
  costBrl: number;
}

export interface CostReport {
  period: CostReportPeriod;
  from: string;
  totals: CostReportTotals;
  byKind?: CostByKind[];
  byAgent: CostByAgent[];
  byModel: CostByModel[];
  topIssues: CostTopIssue[];
  dailySeries: CostDailyPoint[];
}

export const costsApi = {
  report: (companyId: string, period: CostReportPeriod = "mtd") =>
    api.get<CostReport>(
      `/companies/${companyId}/cost-report?period=${period}`,
    ),
};
